import { ErrorMessage } from "@hookform/error-message";
import { Controller } from "react-hook-form";
import cx from "../../utils/cx.ts";
import ErrorLabel from "./errorLabel.tsx";

type Props = {
  name: string;
};

export default function TabbedCheckbox({ name }: Props) {
  const tabs = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];

  return (
    <>
      <Controller
        name={name}
        render={({ field }) => (
          <div className="isolate flex divide-x divide-gray-200 rounded-lg shadow shadow-gray-400">
            {tabs.map((tab, tabIdx) => (
              <div
                key={tab.label}
                className={cx(
                  tab.value === field.value
                    ? "text-gray-900 bg-sky-50"
                    : "text-gray-500 bg-white hover:text-gray-700",
                  tabIdx === 0 ? "rounded-l-lg" : "",
                  tabIdx === tabs.length - 1 ? "rounded-r-lg" : "",
                  "group relative min-w-0 flex-1 overflow-hidden py-2 px-4 text-center text-sm font-medium hover:bg-sky-50 focus:z-10 cursor-pointer",
                )}
                onClick={() => field.onChange(tab.value)}
              >
                <span>{tab.label}</span>
                <span
                  aria-hidden="true"
                  className={cx(
                    tab.value === field.value ? "bg-sky-500" : "bg-transparent",
                    "absolute inset-x-0 bottom-0 h-0.5",
                  )}
                />
              </div>
            ))}
          </div>
        )}
      />
      <ErrorMessage
        name={name}
        render={({ message }) => <ErrorLabel message={message} />}
      />
    </>
  );
}
